import React from "react";
import { isValid, startOfDay } from "date-fns";

import { titles } from "../../../constants/titles";
import {
  clearSuccessMessage,
  clearErrorMessage,
  fetchInitialData,
  exchangeYearNow,
  Context,
  EXCHANGE_YEAR_NOW_REQUEST_SUCCESS_MESSAGE,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import Toast from "../../../molecules/Toast";
import ExchangeSchoolYearBoard from "../../../templates/manager/ExchangeSchoolYearBoard";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useDidMountEffect from "../../../hooks/useDidMountEffect";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);

  React.useEffect(() => {
    if (state.success_message === EXCHANGE_YEAR_NOW_REQUEST_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      dispatch(fetchInitialData());
    }
  }, [dispatch, state.success_message]);

  useDidMountEffect(() => {
    if (state.error) {
      Toast.error(state.error);
    }
    return () => dispatch(clearErrorMessage());
  }, [dispatch, state.error]);

  const exchangeYearNowFunc = React.useCallback(() => {
    dispatch(peep(exchangeYearNow()));
  }, [dispatch, peep]);

  const changed_current_year_plan_date = React.useMemo(() => {
    if (state.manager.school?.changed_current_year_plan_date) {
      const changedYearDate = new Date(
        state.manager.school.changed_current_year_plan_date,
      );
      if (isValid(changedYearDate)) return startOfDay(changedYearDate);
    }

    return null;
  }, [state.manager.school]);

  return (
    <div>
      <Breadcrumb currentTitle={titles.exchangeSchoolYear} />
      <ExchangeSchoolYearBoard
        title={titles.exchangeSchoolYear}
        calling={calling}
        exchangeYearNow={exchangeYearNowFunc}
        change_current_year_status={
          state.manager.school?.change_current_year_status || "open"
        }
        changed_current_year_plan_date={changed_current_year_plan_date}
      />
    </div>
  );
};
